import {Routes} from 'constants/routes';

import React from 'react';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setSingleBeerStyleAC} from 'pages/beerStylesView/store/beerStyleViewSlice';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router';
import {setBeerStyleFiltersAC} from 'store/beerStyles/beerStyleSlice';
import BeerStyle from 'typescript/models/BeerStyle';

export const BeerStylesTableBody = () => {
  const navigate = useNavigate();
  const dispatch = useSetGlobalState();

  const {beerStyles, beerStyleFilters, totalCount} = useGlobalState((state) => state.beerStyles);

  const handleView = (beerStyle: BeerStyle) => {
    dispatch(setSingleBeerStyleAC(beerStyle));
    navigate(`${Routes.BEER_STYLES_VIEW}/${beerStyle.id}`);
  };

  const handleEdit = (beerStyle: BeerStyle) => {
    dispatch(setSingleBeerStyleAC(beerStyle));
    navigate(`${Routes.BEER_STYLES_EDIT}/${beerStyle.id}`);
  };

  const getNextPage = (page: number) => {
    dispatch(setBeerStyleFiltersAC({...beerStyleFilters, page: page + 1, per_page: 15 * (page + 1)}));
  };

  return (
    <div className="beer-styles-table__body" id="scrollable-div">
      <InfiniteScroll
        dataLength={beerStyles.length}
        hasMore={beerStyles.length < totalCount}
        loader={null}
        next={() => {
          getNextPage(beerStyleFilters.page);
        }}
        scrollableTarget="scrollable-div"
      >
        {beerStyles.map((beerStyle) => (
          <div
            key={beerStyle.id}
            className="beer-styles-table__body-row"
            role="button"
            tabIndex={0}
            onClick={() => handleView(beerStyle)}
          >
            <div>{beerStyle.attributes.name}</div>
            <div>
              {beerStyle.attributes.bitterness_from} - {beerStyle.attributes.bitterness_to}
            </div>
            <div>
              {beerStyle.attributes.alcohol_from} - {beerStyle.attributes.alcohol_to}
            </div>
            <div
              role="button"
              aria-label={`Edit ${beerStyle.attributes.name} beer style`}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(beerStyle);
              }}
              data-testid="beer-style-row-edit"
              tabIndex={0}
            >
              <span>
                <Icon icon="edit" />
              </span>
            </div>
          </div>
        ))}
      </InfiniteScroll>
    </div>
  );
};
